import { Link } from "react-router-dom";
import type { Character } from "@/mocks/characters";

interface CharacterCardProps {
  character: Character;
  variant?: "default" | "compact";
}

export default function CharacterCard({ character, variant = "default" }: CharacterCardProps) {
  const target = `/search?q=${encodeURIComponent(character.name)}`;

  if (variant === "compact") {
    return (
      <Link
        to={target}
        className="group flex items-center gap-3 p-2.5 rounded-lg bg-background-100 border border-background-200 hover:border-accent-500 transition-colors cursor-pointer"
      >
        <span className="w-12 h-12 shrink-0 rounded-full overflow-hidden bg-background-200">
          <img
            src={character.avatar}
            alt={`${character.name}（${character.actor}饰）角色头像`}
            title={`${character.name} 角色介绍 - 美国式禁忌2`}
            className="w-full h-full object-cover object-top"
          />
        </span>
        <span className="min-w-0">
          <span className="block text-sm font-medium text-foreground-950 group-hover:text-accent-300 transition-colors truncate">
            {character.name}
          </span>
          <span className="block text-xs text-foreground-500 truncate">{character.role}</span>
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={target}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-accent-500 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
        <img
          src={character.avatar}
          alt={`${character.name}（${character.actor}饰）角色头像`}
          title={`${character.name} 角色介绍 - 美国式禁忌2`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-background-50 to-transparent">
          <p className="font-heading text-base font-bold text-foreground-950">
            {character.name}
          </p>
          <p className="text-xs text-accent-400 mt-0.5">{character.actor} 饰</p>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs font-medium text-foreground-500 mb-2">{character.role}</p>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
          {character.description}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {character.traits.map((trait) => (
            <span
              key={trait}
              className="inline-flex items-center h-6 px-2.5 rounded-full text-xs bg-secondary-100/10 text-secondary-300 border border-secondary-500/30"
            >
              {trait}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}